export type CommentWatcherMode =
	| 'reply-only'
	| 'dm-only'
	| 'reply-and-dm'
	| 'alert-only';

export function resolveCommentWatcherMode(mode: unknown): CommentWatcherMode {
	if (
		mode === 'reply-only' ||
		mode === 'dm-only' ||
		mode === 'reply-and-dm' ||
		mode === 'alert-only'
	) {
		return mode;
	}
	return 'reply-and-dm';
}
